import axios from "axios"
import { useMemo, useState } from "react"
import { getAccessToken } from "../Services/TokenService"

const createApiInstance = (apiUrl, setLogOutTrigger) => {
    const instance = axios.create({ baseURL: apiUrl, withCredentials: true })

    instance.interceptors.request.use((config) => {
        const token = getAccessToken();
        if (token) config.headers.Authorization = `Bearer ${token}`
        return config
    })

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                setLogOutTrigger(prev => !prev)
            }
            return Promise.reject(error)
        }
    )
    return instance
}

const useApi = (apiUrl) => {
    const [logOutTrigger, setLogOutTrigger] = useState(null);
    const api = useMemo(() => apiUrl ? createApiInstance(apiUrl, setLogOutTrigger) : null, [apiUrl])
    return { api, logOutTrigger, setLogOutTrigger }
}

export default useApi




